// Filename - components/SubMenu.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Lock as LockIcon } from '@mui/icons-material';
import GuestPromptModal from './GuestPromptModal';

const SidebarLink = styled(Link)`
    display: none;
    color:black;
    background:#DCE8F7;
    justify-content: space-between;
    align-airportLists: center;
    padding: 20px;
    list-style: none;
    height: 60px;
    text-decoration: none;
    font-size: 18px;

    &:hover {
        background: #DCE8F7;
        border-left: 4px solid #275AA6;
        cursor: pointer;
    }
`;

const SidebarLabel = styled.span`
    margin-left: 16px;
`;

const DropdownLink = styled(Link)`
    background-color: ${(props) => (props.isSelected ? '#ced6e0' : '#DCE8F7')};
    height: 30px;
    padding-left: 2.4rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    color:${(props) => (props.disableflag?'#ced6e0':'#275AA6')};
    font-size: 1rem;
    pointer-events:${(props) => (props.disableflag?'none':'auto')};
    &:hover {
        background: #275AA6;
        color:${(props) => (props.disableflag?'#275AA6':'#C8D5F5')};
        cursor: pointer;
    }
`;

const DropdownButton = styled.div`
    background-color: ${(props) => (props.isSelected ? '#ced6e0' : '#DCE8F7')};
    height: 30px;
    padding-left: 2.4rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: ${(props) => (props.restricted ? '#888' : '#275AA6')};
    font-size: 1rem;
    cursor: pointer;
    opacity: ${(props) => props.restricted ? '0.7' : '1'};
    position: relative;
    &:hover {
        background: #b8c5d9;
        color: #275AA6;
    }
`;

const AirportMenu = ({ airportList, airportCityList, menuRef, selectedIndex,activeMetric,setActiveAirport,activeAirport,setActiveMetric,
                        setMetricSelectedIndex,summaryMetricName,summaryMetricIndex,enabledAirports,handleClick,currentUser}) => { 
    const [subnav, setSubnav] = useState(true);
    const [showGuestModal, setShowGuestModal] = useState(false);
    const [selectedFeature, setSelectedFeature] = useState('');
    
    const showSubnav = () => setSubnav(!subnav);
    
    const handleRestrictedClick = (airportName, event) => {
        event.preventDefault();
        setSelectedFeature(`Airport Data for ${airportName}`);
        setShowGuestModal(true);
    };
    
    const handleCloseModal = () => {
        setShowGuestModal(false);
        setSelectedFeature('');
    };
    return (
        <>
            <SidebarLink
                to={airportList.path}
                onClick={airportList.subNav && showSubnav}
            >
                <div>
                    {airportList.icon}
                    <SidebarLabel>
                        {airportList.title}
                    </SidebarLabel>
                </div>
                <div>
                    {airportList.subNav && subnav
                        ? airportList.iconOpened
                        : airportList.subNav
                        ? airportList.iconClosed
                        : null}
                </div>
            </SidebarLink>
            {subnav &&
                airportList.map((airport, index) => {
                    const disableflag = !Object.hasOwn(enabledAirports,activeMetric)||(Object.hasOwn(enabledAirports,activeMetric)&&enabledAirports[activeMetric].includes(airport))?false:true;
                    // Allow guest access to airports for airport-summary or when no metric is selected (defaults to airport-summary)
                    const isAccessibleToGuests = activeMetric === 'airport-summary' || activeMetric === '';
                    const isRestricted = !currentUser && !isAccessibleToGuests;
                    
                    if (isRestricted) {
                        return (
                            <DropdownButton
                                key={index}
                                isSelected={(airport === activeAirport)}
                                restricted={true}
                                onClick={(e) => handleRestrictedClick(airport, e)}
                            >
                                <SidebarLabel>
                                    {airport +' ('+airportCityList[index]+')'}
                                </SidebarLabel>
                                <LockIcon sx={{ ml: 'auto', mr: 1, fontSize: 14, opacity: 0.6 }} />
                            </DropdownButton>
                        );
                    }
                    
                    return (
                        <DropdownLink
                            to={activeMetric!==''?'/metrics/'+activeMetric+'/'+airport:'/metrics/'+summaryMetricName+'/'+airport}
                            key={index}
                            isSelected={(airport === activeAirport)}
                            disableflag={disableflag}
                            onClick={() => {handleClick(index+menuRef);
                                            setActiveAirport(airport);
                                            if(activeMetric===''){
                                                setActiveMetric(summaryMetricName)
                                                setMetricSelectedIndex(summaryMetricIndex)
                                            };
                            }}
                        >
                            <SidebarLabel>
                                {airport +' ('+airportCityList[index]+')'}
                            </SidebarLabel>
                        </DropdownLink>
                    );
                })}
            
            <GuestPromptModal 
                open={showGuestModal} 
                onClose={handleCloseModal} 
                featureName={selectedFeature}
            />
        </>
    );
};

// const AirportMenu = ({ airportList }) => {
//     return (
//         <>
//             <SidebarLink>
//                 {
//                 airportList.subNav.map((airportList, index) => {
//                     return (
//                     <DropdownLink to={airportList.path} key={index}>
//                         <SidebarLabel>
//                             {airportList.title}
//                         </SidebarLabel>
//                     </DropdownLink>
//                     );
//                 })
//                 }
//             </SidebarLink>
//         </>
//         );
//     };


export default AirportMenu;
